// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAccountForm_wrapper__5F420","submitWrapper":"EditAccountForm_submitWrapper__DAdSJ"};